import React, { useState } from "react";
import { View, TextInput, StyleSheet, Pressable } from "react-native";
import Camera from "@assets/svg/Camera";
import { tokens } from "@components/ds/tokens";
import { normalizeScanValue } from "../helpers";

// Single rounded input with the scan glyph inside it, on the right (spec
// p2 frames 3-4) — replaces the earlier input+"जोड़ें"+camera three-control
// row. The glyph opens the camera sheet (CrateScannerSheet); a typed value
// is confirmed by the keyboard's submit (onSubmitEditing), there's no
// separate visible submit button.

const ScanInput = ({
  placeholder,
  onManualSubmit,
  onScanPress,
  disabled = false,
  testIDPrefix = "receiving-scan-input",
}) => {
  const [value, setValue] = useState("");
  const [focused, setFocused] = useState(false);

  const submit = () => {
    const trimmed = normalizeScanValue(value);
    if (!trimmed || disabled) return;
    onManualSubmit(trimmed);
    setValue("");
  };

  return (
    <View style={styles.wrap}>
      <View style={[styles.inputBox, focused && styles.inputBoxFocused]}>
        <TextInput
          value={value}
          onChangeText={setValue}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={placeholder}
          placeholderTextColor={tokens.textTertiary}
          style={[styles.input, disabled && styles.inputDisabled]}
          editable={!disabled}
          autoCapitalize="characters"
          returnKeyType="done"
          onSubmitEditing={submit}
          testID={`${testIDPrefix}-manual`}
        />
        <Pressable
          onPress={onScanPress}
          disabled={disabled}
          hitSlop={8}
          style={[styles.scanGlyph, disabled && styles.btnDisabled]}
          testID={`${testIDPrefix}-camera`}
        >
          <Camera width={18} height={18} />
        </Pressable>
      </View>
    </View>
  );
};

export default ScanInput;

const styles = StyleSheet.create({
  wrap: {
    paddingHorizontal: tokens.spacing.large,
    paddingVertical: tokens.spacing.medium,
    backgroundColor: tokens.surface,
  },
  inputBox: {
    flexDirection: "row",
    alignItems: "center",
    height: 46,
    borderWidth: 1.5,
    borderColor: tokens.borderMedium,
    borderRadius: tokens.radius.full,
    paddingLeft: tokens.spacing.medium,
    paddingRight: tokens.spacing.small,
    backgroundColor: tokens.surface,
  },
  inputBoxFocused: { borderColor: tokens.info },
  input: {
    flex: 1,
    color: tokens.textPrimary,
    fontSize: 14,
    padding: 0,
  },
  inputDisabled: { color: tokens.textTertiary },
  scanGlyph: {
    width: 34,
    height: 34,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: tokens.radius.full,
  },
  btnDisabled: { opacity: 0.5 },
});
